import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { DebugColor, DebugItemPopover, DebugType, } from "@plansoft-configuration-renderer/debug";
function RenderCellDebug({ row, }) {
    if (!row.id) {
        return _jsx(Fragment, {});
    }
    return (_jsx(DebugItemPopover, { item: row.debug, color: DebugColor.Default, type: DebugType.Other, title: row.id ? row.id : "Debug" }));
}
export default RenderCellDebug;
//# sourceMappingURL=RenderCellDebug.js.map